export const ConfigChatbotConsts = {
  QtdErrosTransfAtend: "QtdErrosTransfAtend",
  MsgCanceladoCliente: "MsgCanceladoCliente",
  MsgTransferidoAtendente: "MsgTransferidoAtendente",
  TemplatePadraoConfirmacaoPresenca: "TemplatePadraoConfirmacaoPresenca"
}

export interface MetaMsgTemplateParametroOrigemOption {
  valor: string;
  descricao: string;
}

export interface MetaMsgTemplateParametroOrigemGrupo {
  nome: string;
  opcoes: MetaMsgTemplateParametroOrigemOption[];
}

export const MetaMsgTemplateParametroNomeMaxLength = 20;

export const MetaMsgTemplateParametroOrigemGrupos: MetaMsgTemplateParametroOrigemGrupo[] = [
  {
    nome: "Paciente",
    opcoes: [
      { valor: "Paciente.Nome", descricao: "Nome completo do paciente do agendamento." },
      { valor: "Paciente.Pessoa.NomeFantasia", descricao: "Nome fantasia da pessoa vinculada ao paciente do agendamento." },
      { valor: "Paciente.PrimeiroNome", descricao: "Primeiro nome do paciente do agendamento." }
    ]
  },
  {
    nome: "Agendamento",
    opcoes: [
      { valor: "Agendamento.Data", descricao: "Data do agendamento no formato dd/MM/yyyy." },
      { valor: "Agendamento.Hora", descricao: "Hora do agendamento no formato HH:mm hrs." },
      { valor: "Agendamento.DataHora", descricao: "Data e hora do agendamento no formato dd/MM/yyyy às HH:mm hrs." },
      { valor: "Agendamento.Classificacao", descricao: "Classificação do agendamento." }
    ]
  },
  {
    nome: "Profissional",
    opcoes: [
      { valor: "Profissional.Nome", descricao: "Nome do profissional ou recurso do agendamento." }
    ]
  },
  {
    nome: "Clínica",
    opcoes: [
      { valor: "Clinica.Nome", descricao: "Nome fantasia da clínica." },
      { valor: "Clinica.EnderecoCompleto", descricao: "Endereço completo da clínica." },
      { valor: "Clinica.Telefone", descricao: "Telefone da clínica." }
    ]
  }
];

export const ConfigAgendamentoConsts = {
  UsaAgendamentoRecorrente: "UsaAgendamentoRecorrente"  
}

/**
 * Subscribe event types.
 * Valores de tipos de eventos aos quais uma sessão de 
 * usuário da API estará apta a receber mensagens
 */
export const WhatsAppApiEvents = {
  EventMessage: "Message",
  EventReadReceipt: "ReadReceipt",
  EventPresence: "Presence",
  EventHistoricSync: "HistoricSync",
  EventChatPresence: "ChatPresence",
  EventCall: "Call"
}
